module.exports = __webpack_public_path__ + "img/AD.4aed3218.svg";